import { useState } from "react";
import { useLogin } from "../hooks/useLogin";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/login-logo.png";

const LoginComponent = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, error, isLoading } = useLogin();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const jobId = localStorage.getItem("pendingJobApplication");
    const jobTitle = localStorage.getItem("pendingJobTitle");

    const loginSuccess = await login(email, password);

    if (loginSuccess) {
      if (jobId && jobTitle) {
        localStorage.removeItem("pendingJobApplication");
        localStorage.removeItem("pendingJobTitle");
        navigate(
          `/api/jobs/job-details/${jobId}/${encodeURIComponent(jobTitle)}`
        );
      } else {
        navigate("/api/dashboard");
      }
    }
  };

  return (
    <div className="container vh-100 bg-light shadow shadow-lg">
      <div className="row h-100 g-0">
        {/* Left Panel - Welcome Section */}
        <div className="col-lg-6 d-none d-lg-flex bg-primary text-white p-5">
          <div className="d-flex flex-column justify-content-center w-100">
            <h1 className="display-4 fw-bold mb-4">Welcome Back</h1>
            <p className="fs-5 mb-5">Please login to access your account</p>

            <div className="d-flex flex-column gap-3">
              <div className="d-flex align-items-center gap-3">
                <i className="fa fa-check-circle fs-4"></i>
                <span className="fs-5">Access to all courses</span>
              </div>
              <div className="d-flex align-items-center gap-3">
                <i className="fa fa-check-circle fs-4"></i>
                <span className="fs-5">Personal dashboard</span>
              </div>
              <div className="d-flex align-items-center gap-3">
                <i className="fa fa-check-circle fs-4"></i>
                <span className="fs-5">Job application tracking</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel - Login Form */}
        <div className="col-lg-6 d-flex align-items-center justify-content-center p-4">
          <div className="w-100" style={{ maxWidth: "450px" }}>
            <div className="text-center mb-5">
              <img
                src={logo}
                alt="Logo"
                className="img-fluid mb-4"
                style={{ height: "70px" }}
              />
              <h2 className="fw-bold mb-3">Sign In</h2>
              <p className="text-muted">Enter your credentials to continue</p>
            </div>

            {error && !isLoading && (
              <div className="alert alert-danger d-flex align-items-center mb-4">
                <i className="fa fa-exclamation-circle me-2"></i>
                <div>{error}</div>
              </div>
            )}

            <form onSubmit={handleSubmit} className="mb-3">
              {/* Email Input */}
              <div className="mb-4">
                <div className="input-group border-bottom pb-2">
                  <span className="input-group-text bg-transparent border-0 pe-1">
                    <i className="fa fa-envelope text-muted"></i>
                  </span>
                  <div className="form-floating flex-grow-1">
                    <input
                      type="email"
                      className="form-control border-0 ps-0 shadow-none"
                      id="email"
                      placeholder=" "
                      required
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <label htmlFor="email" className="text-muted">
                      Email Address
                    </label>
                  </div>
                </div>
              </div>

              {/* Password Input */}
              <div className="mb-4">
                <div className="input-group border-bottom pb-2">
                  <span className="input-group-text bg-transparent border-0 pe-1">
                    <i className="fa fa-lock text-muted"></i>
                  </span>
                  <div className="form-floating flex-grow-1">
                    <input
                      type="password"
                      className="form-control border-0 ps-0 shadow-none"
                      id="password"
                      placeholder=" "
                      required
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <label htmlFor="password" className="text-muted">
                      Password
                    </label>
                  </div>
                </div>
              </div>

              {/* Remember Me & Forgot Password */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="rememberMe"
                  />
                  <label
                    className="form-check-label small"
                    htmlFor="rememberMe"
                  >
                    Remember me
                  </label>
                </div>
                <Link
                  to="/api/users/forgot-password"
                  className="text-primary text-decoration-none small"
                >
                  Forgot password?
                </Link>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="btn btn-primary btn-lg w-100 mb-4 py-3 fw-bold"
                disabled={isLoading || !email || !password}
              >
                {isLoading ? (
                  <>
                    <i className="fa fa-spinner fa-spin me-2"></i>{" "}
                    Authenticating...
                  </>
                ) : (
                  <>
                    <i className="fa fa-sign-in-alt me-2"></i> Login
                  </>
                )}
              </button>

              {/* Sign Up Link */}
              <div className="text-center text-muted small mt-4">
                Don't have an account?{" "}
                <Link
                  to="/api/users/register"
                  className="text-primary fw-medium text-decoration-none"
                >
                  Create account
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginComponent;
